
import {
    GET_ALL_AMENITIES
   } from "../../constant/ActionType";
   
   export default function GetAllAmenities(state = {
       AllAmenitiesData: [],
   
   }, action) {
       switch (action.type) {
           case GET_ALL_AMENITIES:
               return {
                   ...state,
                   AllAmenitiesData: action?.data?.data,
               };
   
           default:
       }
   
       return state;
   }